<template>
  <!--begin::Toolbar wrapper-->
  <div class="d-flex flex-shrink-0">
    <!--begin::Invite user-->
    <div class="d-flex ms-3">
      <a
        v-if="userGuard(permission.value) == true"
        href="#"
        class="btn btn-flex btn-sm flex-center btn-bg-white btn-text-gray-500 btn-active-color-primary"
        tooltip="New Member"
        data-bs-toggle="modal"
        data-bs-target="#add-audit-planning"
      >
        <span class="svg-icon svg-icon-2 svg-icon-primary me-0 me-md-2">
          <inline-svg src="media/icons/duotune/arrows/arr075.svg" />
        </span>
        <span class="d-none d-md-inline">{{ translate("audit_topbar") }}</span>
      </a>
    </div>

    <!--end::Chat-->
  </div>
  <!--end::Toolbar wrapper-->
</template>

<script setup>
import { useI18n } from "vue-i18n";
import { userGuard } from "@/store/utils/userGourad";
import { ref } from "vue";
import AuditPlanningModule from "@/store/modules/Audit/AuditPlanningModule";
const { t, te } = useI18n();
const permission = ref("ManageAuditPlans");
const translate = (text) => {
  if (te(text)) {
    return t(text);
  } else {
    return text;
  }
};
</script>
